import sizeUtils from '@utils/sizeUtils'
import BaseModel from '@/models/base-model'

export default class Vector extends BaseModel {
  constructor (vector) {
    super(vector)
    this._createdBy = undefined
    this._createdAt = undefined
    this._thumbnailUrl = undefined
    this._size = '0 KB'
    this._isResult = false
    this._itemType = 'vector'
    this._styleId = vector.style_id ? vector.style_id : undefined
  }

  transformSize (size) {
    if (size !== undefined && size !== null && size !== '') {
      return sizeUtils.transfSize(size)
    } else {
      return '0 KB'
    }
  }
  get size () {
    return this._size
  }
  get createdBy () {
    return this._createdBy
  }
  get createdAt () {
    return this._createdAt
  }
  get thumbnailUrl () {
    return this._thumbnailUrl
  }
  get isResult () {
    return this._isResult
  }
  get styleId () {
    return this._styleId
  }
}



// WEBPACK FOOTER //
// ./src/models/vector/vector.js